
export default {
  name: 'VsSection',
  inheritAttrs: false,
  props: {
    type: {
      type: String,
      default: null
    },
    background: {
      type: [String, Object],
      default: null
    },
    gutterX: {
      type: [Boolean, String],
      default: null
    },
    gutterY: {
      type: [Boolean, String],
      default: null
    },
    contain: {
      type: [Boolean, Object],
      default: false
    },
    center: {
      type: Boolean,
      default: false
    },
    borderX: {
      type: [Boolean, String, Object],
      default: null
    },
    borderY: {
      type: [Boolean, String, Object],
      default: null
    },
    autoBorder: {
      type: Boolean,
      default: false
    },
    height: {
      type: [String, Object],
      default: null
    },
    fillScreen: {
      type: Boolean,
      default: false
    },
    fitScreen: {
      type: Boolean,
      default: false
    },
    nested: {
      type: Boolean,
      default: false
    }
  },
  vessel: {
    section: {
      $attrs: 'all',
      $background: 'backgroundColor',
      $gutterYSize: 'paddingY',
      $gutterXSize: 'paddingX',
      $borderX: ['borderLeftWidth', 'borderRightWidth'],
      $borderY: {
        borderBottomWidth(val) {
          return this.autoBorder ? false : val
        },
        borderTopWidth(val) {
          return this.autoBorder ? !this.first : val
        }
      },
      $center: {
        textAlign(val) {
          return val ? 'center' : null
        }
      },
      $fillScreen: {
        minHeight(val) {
          return val && 'screen'
        }
      },
      $height: {
        height(val) {
          return this.fitScreen ? 'screen' : val
        }
      }
    }
  },
  data() {
    return {
      first: false,
      gutters: {
        x: {
          small: {
            all: 'sm',
            md: 'md'
          },
          medium: {
            all: 'sm',
            md: 'md',
            lg: 'lg'
          },
          large: {
            all: 'sm',
            md: 'md',
            lg: '2xl',
            xl: '4xl'
          }
        },
        y: {
          small: {
            all: 'sm',
            md: 'md',
            lg: 'lg'
          },
          medium: {
            all: 'lg',
            md: 'xl',
            lg: '2xl'
          },
          large: {
            all: 'xl',
            md: '2xl',
            xl: '4xl'
          }
        }
      }
    }
  },
  computed: {
    tag() {
      const { type } = this
      const { columns, gap } = this.$attrs

      if (type || gap || columns) {
        const row = ['grid', 'flex']
        const tag = type || (columns ? 'grid' : 'stack')

        return row.includes(tag) ? `vs-${tag}-row` : `vs-${tag}`
      } else {
        return 'vs-node'
      }
    },
    gutterXSize() {
      return this.gutterFor('x', this.gutterX)
    },
    gutterYSize() {
      return this.gutterFor('y', this.gutterY)
    }
  },
  methods: {
    gutterFor(side, val) {
      const size = val == true ? 'small' : val
      return val ? this.gutters[side][size] : null
    },
    findFirst() {
      const self  = this.nested ? this.$vnode.parent.context : this.$vnode.context
      const first = self.$parent.$children[0]

      this.first = self._uid == first._uid
    }
  },
  created() {
    if (this.autoBorder)
      this.findFirst()
  }
}
